
<template>
<b-card lass="overflow-auto" v-if="mapListForTable.length != 0">
    <map-table-result v-bind:mapListForTable="mapListForTable"></map-table-result>
</b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import MapTableResult from './MapTableResult'

export default {
  name: 'map-search',
  components: { MapTableResult },
  computed: {
    ...mapGetters({
      mapListForTable: 'getMapListForTable'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/MapSearch.vue